import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f7',
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    }}>
      {/* Header */}
      <header style={{
        background: 'white',
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderBottom: '1px solid #eee',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#333',
            padding: '4px 8px',
          }}
          aria-label="Back"
        >
          ←
        </button>
        <h1 style={{ margin: 0, fontSize: '20px', color: '#333', fontWeight: 700 }}>
          Contact Us
        </h1>
      </header>

      <div style={{ maxWidth: 600, margin: '0 auto', padding: '32px 20px' }}>

        {/* Intro */}
        <p style={{
          color: '#666',
          fontSize: '15px',
          lineHeight: 1.6,
          marginBottom: '32px',
          textAlign: 'center',
        }}>
          We're here to help. Reach out to us through any of the channels below
          and we'll get back to you as soon as possible.
        </p>

        {/* Contact Cards */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* Phone */}
          <a
            href="tel:+2347051061420"
            style={{ textDecoration: 'none' }}
          >
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              transition: 'transform 0.15s',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #8B0D1F 0%, #C8102E 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '22px',
                flexShrink: 0,
              }}>
                📞
              </div>
              <div>
                <p style={{ margin: 0, fontSize: '12px', color: '#999', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Phone Support
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '17px', fontWeight: 700, color: '#C8102E' }}>
                  +2347035243114
                </p>
                <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#aaa' }}>
                  Tap to call
                </p>
              </div>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:support@godlymatch.org"
            style={{ textDecoration: 'none' }}
          >
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #8B0D1F 0%, #C8102E 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '22px',
                flexShrink: 0,
              }}>
                ✉️
              </div>
              <div>
                <p style={{ margin: 0, fontSize: '12px', color: '#999', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Email Support
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '17px', fontWeight: 700, color: '#C8102E' }}>
                  support@godlymatch.org
                </p>
                <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#aaa' }}>
                  Tap to email
                </p>
              </div>
            </div>
          </a>

          {/* Address */}
          <a
            href="https://maps.google.com/?q=Osapa+London,+Lekki,+Lagos"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #8B0D1F 0%, #C8102E 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '22px',
                flexShrink: 0,
              }}>
                📍
              </div>
              <div>
                <p style={{ margin: 0, fontSize: '12px', color: '#999', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Business Address
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '15px', fontWeight: 700, color: '#333', lineHeight: 1.4 }}>
                  3M, Bromley, Cadogan Estate
                </p>
                <p style={{ margin: '2px 0 0', fontSize: '14px', color: '#666' }}>
                  Osapa London, Lekki, Lagos
                </p>
                <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#aaa' }}>
                  Tap to open in Maps
                </p>
              </div>
            </div>
          </a>

        </div>

        {/* Response time note */}
        <div style={{
          marginTop: '32px',
          background: 'rgba(200, 16, 46, 0.06)',
          borderRadius: '12px',
          padding: '16px 20px',
          textAlign: 'center',
        }}>
          <p style={{ margin: 0, fontSize: '14px', color: '#8B0D1F', fontWeight: 500 }}>
            🕐 We typically respond within 24 hours on business days.
          </p>
        </div>

      </div>
    </div>
  );
}